import React, { Component } from "react"
import { Provider } from "react-redux"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import Theme from "./style/common.style"
import redux from "./store"

import Login from "./containers/Auth"
import LoginCallback from "./containers/Auth/callback"
import PrivateLayout from "./components/Layout"

import { Profile, EditProfile } from "./containers/Profile"
import {
  Search,
  SearchResult,
  EditProfile as MemberEditProfile,
} from "./containers/Search"
import { UserRegister } from "./containers/UserRegister"
import {
  AdminManagement,
  RegisterManagement,
  Welcome,
} from "./containers/Management"
import { PrinterSelection } from "./containers/PrinterSetup"

import { PersistGate } from "redux-persist/integration/react"
import { BranchReport, TransactionReport } from "./containers/SettlementReport"
export default class App extends Component {
  render() {
    return (
      <Provider store={redux.store}>
        <PersistGate loading={null} persistor={redux.persistor}>
          <Theme>
            <BrowserRouter>
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/welcome" component={Welcome} />
                <Route exact path="/callback" component={LoginCallback} />
                <Route exact path="/profile/edit" component={EditProfile} />
                <PrivateLayout>
                  <Switch>
                    <Route path="/profile" component={Profile} />
                    <Route exact path="/search" component={Search} />
                    <Route
                      path="/search/:memberId/edit"
                      component={MemberEditProfile}
                    />
                    <Route path="/search/:memberId" component={SearchResult} />
                    <Route path="/register" component={UserRegister} />
                    <Route
                      exact
                      path="/management/admin"
                      component={AdminManagement}
                    />
                    <Route
                      exact
                      path="/management/register"
                      component={RegisterManagement}
                    />
                    <Route path="/settings" component={PrinterSelection} />
                    <Route path="/settlement-report" component={BranchReport} />
                    <Route
                      path="/transaction-report"
                      component={TransactionReport}
                    />
                  </Switch>
                </PrivateLayout>
              </Switch>
            </BrowserRouter>
          </Theme>
        </PersistGate>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js